var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkills(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CEE8FA"
    },
    points: "187.282,163.138 207.786,195.838 245.222,205.235 220.458,234.841 223.09,273.348  187.282,258.945 151.472,273.348 154.104,234.841 129.342,205.235 166.778,195.838 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D527C"
    },
    d: "M151.474,288.407c-3.134,0-6.24-0.977-8.853-2.876c-4.194-3.048-6.526-8.038-6.173-13.21 l2.22-32.465l-20.878-24.958c-3.325-3.977-4.372-9.385-2.771-14.315c1.602-4.93,5.627-8.69,10.656-9.952l31.562-7.921l17.286-27.57 c2.754-4.393,7.575-7.06,12.759-7.06s10.005,2.667,12.759,7.06l17.286,27.57l31.56,7.921c5.028,1.262,9.053,5.022,10.656,9.952 c1.601,4.93,0.554,10.339-2.771,14.315l-20.878,24.96l2.22,32.465c0.354,5.173-1.977,10.163-6.173,13.21 c-4.195,3.046-9.662,3.723-14.47,1.789l-30.19-12.143l-30.191,12.143C155.278,288.048,153.371,288.407,151.474,288.407z  M156.3,213.993l9.356,11.184c2.492,2.982,3.736,6.811,3.473,10.689l-0.994,14.548l13.529-5.442c3.607-1.45,7.632-1.45,11.238,0 l13.527,5.441l-0.994-14.547c-0.265-3.878,0.979-7.707,3.473-10.689l9.356-11.184l-14.143-3.549 c-3.769-0.946-7.028-3.313-9.093-6.606l-7.746-12.354l-7.746,12.354c-2.065,3.293-5.323,5.659-9.093,6.606L156.3,213.993z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D527C"
    },
    d: "M382.658,206.982h-85.835c-8.315,0-15.059-6.742-15.059-15.059c0-8.317,6.743-15.059,15.059-15.059 h85.835c8.315,0,15.059,6.742,15.059,15.059S390.975,206.982,382.658,206.982z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D527C"
    },
    d: "M352.523,259.622h-55.698c-8.315,0-15.059-6.742-15.059-15.059c0-8.317,6.743-15.059,15.059-15.059 h55.698c8.315,0,15.059,6.742,15.059,15.059C367.581,252.88,360.838,259.622,352.523,259.622z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CEE8FA"
    },
    points: "187.282,325.887 207.786,358.587 245.222,367.982 220.458,397.589 223.09,436.096  187.282,421.692 151.472,436.096 154.104,397.589 129.342,367.982 166.778,358.587 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D527C"
    },
    d: "M223.09,451.155c-1.897,0-3.804-0.358-5.617-1.087l-30.19-12.143l-30.191,12.143 c-4.808,1.934-10.276,1.257-14.47-1.789c-4.194-3.048-6.527-8.038-6.173-13.21l2.22-32.465l-20.879-24.96 c-3.325-3.977-4.372-9.385-2.771-14.315c1.602-4.93,5.627-8.69,10.656-9.952l31.562-7.921l17.286-27.57 c2.754-4.393,7.575-7.06,12.759-7.06s10.005,2.667,12.759,7.06l17.286,27.57l31.56,7.921c5.028,1.262,9.053,5.022,10.656,9.952 c1.601,4.93,0.554,10.338-2.771,14.315l-20.878,24.96l2.22,32.465c0.354,5.173-1.977,10.163-6.173,13.21 C229.329,450.178,226.224,451.155,223.09,451.155z M156.3,376.742l9.356,11.184c2.492,2.982,3.736,6.811,3.473,10.689 l-0.994,14.548l13.529-5.442c3.607-1.45,7.632-1.45,11.238,0l13.527,5.442l-0.994-14.548c-0.265-3.878,0.979-7.707,3.473-10.689 l9.356-11.184l-14.143-3.549c-3.769-0.946-7.028-3.313-9.093-6.606l-7.746-12.354l-7.746,12.354 c-2.065,3.293-5.323,5.659-9.093,6.606L156.3,376.742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D527C"
    },
    d: "M382.658,369.73h-85.835c-8.315,0-15.059-6.742-15.059-15.059s6.743-15.059,15.059-15.059h85.835 c8.315,0,15.059,6.742,15.059,15.059S390.975,369.73,382.658,369.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D527C"
    },
    d: "M352.523,422.368h-55.698c-8.315,0-15.059-6.742-15.059-15.059c0-8.317,6.743-15.059,15.059-15.059 h55.698c8.315,0,15.059,6.742,15.059,15.059C367.581,415.627,360.838,422.368,352.523,422.368z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 67.76,
    y: 57.269,
    style: {
      fill: "#CEE8FA"
    },
    width: 105.412,
    height: 48.142
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.824,
    y: 57.269,
    style: {
      fill: "#CEE8FA"
    },
    width: 105.412,
    height: 48.142
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D527C"
    },
    d: "M323.765,105.412c0,8.317,6.743,15.059,15.059,15.059H444.24c8.315,0,15.059-6.742,15.059-15.059 V57.27c0-8.317-6.743-15.059-15.059-15.059h-90.357V15.059C353.882,6.742,347.139,0,338.824,0H173.176 c-8.315,0-15.059,6.742-15.059,15.059v27.153H67.76c-8.315,0-15.059,6.742-15.059,15.059v48.142v391.529 c0,8.317,6.743,15.059,15.059,15.059h376.48c8.315,0,15.059-6.742,15.059-15.059V191.923c0-8.317-6.743-15.059-15.059-15.059 s-15.059,6.742-15.059,15.059v289.959H82.819V120.471h90.357h105.969c8.315,0,15.059-6.742,15.059-15.059 s-6.743-15.059-15.059-15.059h-90.91V57.27V30.118h135.529V57.27V105.412z M82.819,72.329h75.299v18.024H82.819V72.329z  M429.181,90.353h-75.299V72.329h75.299V90.353z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkills);
export default __webpack_public_path__ + "static/media/skills.266c6b3862bbacd864541c0f79730393.svg";
export { ForwardRef as ReactComponent };